const listeners = new Set();

const defaultConfirmOptions = {
  title: '확인',
  color: 'primary',
  buttonTrueText: '확인',
  buttonFalseText: '취소',
  buttonTrueColor: 'primary',
  buttonFalseColor: 'grey',
  width: 400,
  html: false,
  persistent: false,
  icon: null,
};

const defaultPromptOptions = {
  title: '입력',
  color: 'primary',
  label: '값',
  message: '',
  rules: [],
  buttonTrueText: '확인',
  buttonFalseText: '취소',
  buttonTrueColor: 'primary',
  buttonFalseColor: 'grey',
  width: 400,
  persistent: true,
  initialValue: '',
};

let activeRequest = null;

function notify() {
  listeners.forEach((listener) => listener(activeRequest));
}

function replaceActiveRequest(nextRequest) {
  if (!activeRequest) {
    activeRequest = nextRequest;
    notify();
    return;
  }

  const fallbackValue = activeRequest.type === 'confirm' ? false : null;
  const { resolve } = activeRequest;
  activeRequest = nextRequest;
  notify();
  resolve(fallbackValue);
}

export function subscribeDialogService(listener) {
  listeners.add(listener);
  listener(activeRequest);

  return () => {
    listeners.delete(listener);
  };
}

export function closeActiveDialog(result) {
  if (!activeRequest) {
    return;
  }

  const { resolve } = activeRequest;
  activeRequest = null;
  notify();
  resolve(result);
}

export function confirmDialog(message, options = {}) {
  return new Promise((resolve) => {
    replaceActiveRequest({
      ...defaultConfirmOptions,
      ...options,
      type: 'confirm',
      message,
      resolve,
    });
  });
}

export function promptDialog(options = {}) {
  return new Promise((resolve) => {
    replaceActiveRequest({
      ...defaultPromptOptions,
      ...options,
      type: 'prompt',
      resolve,
    });
  });
}
